// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ShrinkIconSignature {
  Element: SVGSVGElement;
}

export const ShrinkIcon: TOC<ShrinkIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.414 9.00003H19V11H13V5.00003H15V7.58603L20.293 2.29303L21.707 3.70703L16.414 9.00003ZM9 16.414L3.707 21.707L2.293 20.293L7.586 15H5V13H11V19H9V16.414Z"/>
</svg>
</template>;